<p-confirmDialog key="redeemgroupwarning" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="redeemgroup" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Options-->
<div class="MainGrid">
	<label>School:</label>
	<label class="InfoText">{{ SchoolName }}</label>

	<label>Group:</label>
	<label class="InfoText">{{ GroupName }}</label>

	<label>Point:</label>
	<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="SelectedPoint">
		<option *ngFor="let r of lstPoints" [ngValue]="r">
			{{ r.PointsItemDesc }}
		</option>
	</select>

	<label>Value:</label>
	<label class="InfoText">{{ SelectedPoint == undefined ? "" : SelectedPoint.PointsItemValue }}</label>

	<!-- <label>Auto-Assign to New Group Members</label>
    <input type="checkbox" class="form-control" [(ngModel)]="AddStudentPrompt"> -->
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
